module.exports = __webpack_public_path__ + "img/logo-um-sl.93fc6d43.svg";